import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import Constants from "../common/Constants";

const PlTripeConfirmationModal = React.forwardRef((props, ref) => {
  // const navigate = useNavigate();
  let userData = useSelector((state) => state?.user.data); // User Details from Store
  const [userRoleData, serUserRoleData] = useState();
  useEffect(() => {
    if (userData?.roles) {
      const allowedRoles = ["LOGISTICS-STAFF"];
      const isAllowed = userData.roles.some((r) =>
        allowedRoles.includes(r.roleId),
      );
      serUserRoleData(isAllowed);
    }
  }, [userData]);

  const [errorMsg, setErrorMsg] = useState("");
  const [getRemarks, setRemarks] = useState("");

  const handleInputChange = (event) => {
    setErrorMsg("");
    setRemarks(event.target.value);
  };

  // Handle form OK
  //  const okConfirm = async () => {
  //   if (getRemarks && getRemarks.trim() !== "") {
  //     props.onvaluechange(getRemarks);
  //     props.onHide();

  //     if (typeof props.onConfirm === "function") {
  //       props.onConfirm();
  //     }
  //   } else {
  //     setErrorMsg("*Please enter the remarks");
  //   }
  // };

  const okConfirm = () => {
    if (!getRemarks || getRemarks.trim() === "") {
      setErrorMsg("*Please enter the remarks");
      return;
    }

    if (typeof props.onConfirm === "function") {
      props.onConfirm(getRemarks.trim());
    }

    props.onHide();
  };

  useEffect(() => {
    setRemarks("");
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="md"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {/* <i className="bi bi-check2-circle"></i> */}
          <span className="modal-title">Confirm Trip Request</span>
          {/* <p className='subText'>Confirm the below given statement</p> */}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        <form className="space-y-4">
          <Row>
            <Col
              xs={12}
              md={12}
              lg={12}
              className="commLeftRightPadding text-left mt-2"
            >
              {!userRoleData && (
                <p>
                  A previous trip is currently in transit. Click “OK” to
                  continue.{" "}
                </p>
              )}
              {userRoleData && (
                <p>
                  A previous trip is currently in transit. Only Admin can Allow.
                </p>
              )}
            </Col>
            {!userRoleData && (
              <Col xs={12} md={12} lg={12} className="commLeftRightPadding">
                <TextAreaField
                  className="inputBox"
                  label="Please Enter the Remarks*"
                  name="getRemarks"
                  placeholder=""
                  value={getRemarks}
                  onChange={handleInputChange}
                />
              </Col>
            )}
          </Row>

          <Row className="justify-end">
            {!userRoleData && (
              <Col xs={4} md={3} lg={3} className="commLeftRightPadding">
                <button
                  type="button"
                  onClick={() => okConfirm()}
                  className="btn btn-primary w-full justify-center rounded-md"
                >
                  OK
                </button>
              </Col>
            )}
            <Col xs={4} md={3} lg={3} className="commLeftRightPadding">
              <button
                type="button"
                onClick={() => props.onHide()}
                className="btn btn-danger w-full justify-center rounded-md"
              >
                Cancel
              </button>
            </Col>
            <Col xs={12} md={12} lg={12} className="commLeftRightPadding">
              <p className="errorMsg"> {errorMsg} </p>
            </Col>
          </Row>
        </form>
      </Modal.Body>
    </Modal>
  );
});

export default PlTripeConfirmationModal;
